import { DynamicFormDataEntry } from "pages/OfficeAutomation/FormBuilder/components/DynamicFormDataEntry/DynamicFormDataEntry";
import { ComponentParams } from "types/types";
import { findValueByKey } from "utils/helpers";
import { AttachmentViewer } from "./AttachmentViewer";
import { useEffect, useState } from "react";
import { getAttachmentViewers } from "./api";
import { Loading } from "components/Loading/loading";
import { ENDPOINTS } from "utils/endpoints";

export interface DynamicComponentHOCProps {
  component: any,
  componentName?: any,
  componentParams: string,
  referenceId?: any,
  processId?: any,
  RequesterPositionId?: any,
  taskTitle?: any,
  Id?: any,
  jobId?: any,
  sourceId?: any,
  SourceData?: any,
  showInDetail?: any,
  JobNo?: any,
  TaskId?: any,
  modeParams?: any,
  useGenerate?: any,
  stepParams?: any,
  Name?: any,
  handleCancelForm: () => void,
  onHide: (usenavigate?) => void,
  formCallBack?: (usenavigate?) => void,
  reload?: (ans: boolean) => void,
  closeForm?: () => void,
  handleShowReferenceStepper?: (referenceId: string) => void
  buttonPrintObjCallBack?: (obj: any) => void
  inDynamicForms?: any;
  parentISCartable?:any
  modalFormLabelCallBack?:any
  handleCallAttachment?:any
  showAttachmant?:any
  tmpOwnerId?:any
  callAttachmentMoveTemp?:any
  setShowAttachmentByDynamicForm?:any
  
}

export const DynamicComponentHOC = ({buttonPrintObjCallBack,setShowAttachmentByDynamicForm,callAttachmentMoveTemp,tmpOwnerId,handleCallAttachment,showAttachmant,modalFormLabelCallBack,formCallBack,parentISCartable=false,inDynamicForms,componentName ,useGenerate,sourceId,SourceData, component: Component,showInDetail,JobNo, componentParams,TaskId,jobId=null, referenceId, onHide, processId,RequesterPositionId,taskTitle, Id,Name , modeParams,stepParams,closeForm, handleCancelForm, reload, handleShowReferenceStepper }: DynamicComponentHOCProps) => {
  let mode: string = "create";
  let type;
  let step;
  let sourceDataParam;
  let ParentForm;
  let ViewMode;
 let DependentSource
 let WarehouseIOKind


  if (componentParams && componentParams != "") {
    let paramsObject: ComponentParams = JSON.parse(componentParams.toLowerCase()?.trim());
    sourceDataParam =JSON.parse(componentParams).SourceData?.trim() ;
    DependentSource=JSON.parse(componentParams)?.DependentSource?.trim()=='false'?false:true
    mode = findValueByKey(paramsObject, "mode")?.trim() ;
    type =JSON.parse(componentParams).Type ?JSON.parse(componentParams).Type?.trim():JSON.parse(componentParams).type?.trim()
    // findValueByKey(paramsObject, "type") ;
    step = findValueByKey(paramsObject, "step") ;
    ParentForm = findValueByKey(JSON.parse(componentParams), "ParentForm")?.trim() ;
    ViewMode = findValueByKey(JSON.parse(componentParams), "ViewMode")?.trim() ;
    WarehouseIOKind=JSON.parse(componentParams)?.WarehouseIOKind?.trim()
    }
    const [loading, setLoading] = useState<any>(false);
    const [response, setResponse] = useState<any>();


    async function getAttachmentViewersAsync() {
  
        setLoading(false)
        try {
            const res = await getAttachmentViewers(window.location.href.includes("/my-own") ?jobId : referenceId , window.location.href.includes("/my-own") ?ENDPOINTS.clientPortal.clientPortal.attachment  : ENDPOINTS.cartable.attachment )
            setResponse(res.Data ) 
        } catch (error:any) {
            
        }
        setLoading(true)
    }

    useEffect(() => {
        if(jobId&&(ViewMode=="file"||ViewMode=="fileWithForm")){
            getAttachmentViewersAsync()
        }
    }, [ jobId ,ViewMode]);


    useEffect(() => {
        if(TaskId){
          sessionStorage.setItem('taskID',TaskId)
        }
      return ()=>{
        if(sessionStorage.getItem('taskID')){sessionStorage.removeItem('taskID')}
      }
    }, [ TaskId]);




    

  return (
    <>
    {((ViewMode=="file"||ViewMode=="fileWithForm") && response&&response.length>0 )? <>
    {loading ?
          <>
          <div className="card-body" style={{height:'40%'}}>
          <AttachmentViewer showOnForm={true}  listAttachment={response}/>
          </div>
          {(ViewMode=="fileWithForm")&&
          <>
             {componentName ? 
               <DynamicFormDataEntry
                setShowAttachmentByDynamicForm={setShowAttachmentByDynamicForm}//شده و تب پیوست را نمایش میدهد و این پراپز کال بک است true داینامیک فرم اگر شامل کامپوننت پیوست باشد مقدار استیت 
                 callAttachmentMoveTemp={callAttachmentMoveTemp} reload={reload} handleCallAttachment={handleCallAttachment} buttonPrintObjCallBack={buttonPrintObjCallBack} step={ stepParams ?stepParams   :step}  modalFormLabelCallBack={modalFormLabelCallBack} dataEntry={true} parentISCartable={parentISCartable} ReferenceId={referenceId}  PRJ_UID={processId}   formKey={componentName} id={Id}jobId={jobId} mode={modeParams ?modeParams :mode } onHide={onHide} handleShowReferenceStepper={handleShowReferenceStepper}/>
               :
             <Component tmpOwnerId={tmpOwnerId} callAttachmentMoveTemp={callAttachmentMoveTemp} WarehouseIOKind={WarehouseIOKind} DependentSource={DependentSource} formCallBack={formCallBack} buttonPrintObjCallBack={buttonPrintObjCallBack} sourceDataParam={sourceDataParam}useGenerate={useGenerate} RequesterPositionId={RequesterPositionId} closeForm={closeForm} SourceData={SourceData}  inDynamicForms={inDynamicForms} sourceId={sourceId}  taskTitle={taskTitle} ParentForm={ParentForm}showInDetail={showInDetail}JobNo={JobNo} step={ stepParams ?stepParams   :(step?step:undefined)} Name={Name} taskId={TaskId} type={type} mode={modeParams ?modeParams :mode }jobId={jobId} onHide={onHide} Id={Id} processId={processId} referenceId={referenceId} handleCancelForm={handleCancelForm} reload={reload} handleShowReferenceStepper={handleShowReferenceStepper} />
             }
          </>
          
          }

      </>
    
       :<Loading/>
  }
    
    
    </>
      :
      <>
      {componentName ? 
        <DynamicFormDataEntry
         setShowAttachmentByDynamicForm={setShowAttachmentByDynamicForm}//شده و تب پیوست را نمایش میدهد و این پراپز کال بک است true داینامیک فرم اگر شامل کامپوننت پیوست باشد مقدار استیت 
          callAttachmentMoveTemp={callAttachmentMoveTemp} reload={reload} handleCallAttachment={handleCallAttachment} buttonPrintObjCallBack={buttonPrintObjCallBack} step={ stepParams ?stepParams   :step}  modalFormLabelCallBack={modalFormLabelCallBack} dataEntry={true} parentISCartable={parentISCartable} ReferenceId={referenceId}  PRJ_UID={processId}   formKey={componentName} id={Id}jobId={jobId} mode={modeParams ?modeParams :mode } onHide={onHide} handleShowReferenceStepper={handleShowReferenceStepper}/>
        :
      <Component tmpOwnerId={tmpOwnerId} callAttachmentMoveTemp={callAttachmentMoveTemp} WarehouseIOKind={WarehouseIOKind} DependentSource={DependentSource} formCallBack={formCallBack} buttonPrintObjCallBack={buttonPrintObjCallBack} sourceDataParam={sourceDataParam}useGenerate={useGenerate} RequesterPositionId={RequesterPositionId} closeForm={closeForm} SourceData={SourceData}  inDynamicForms={inDynamicForms} sourceId={sourceId}  taskTitle={taskTitle} ParentForm={ParentForm}showInDetail={showInDetail}JobNo={JobNo} step={ stepParams ?stepParams   :(step?step:undefined)} Name={Name} taskId={TaskId} type={type} mode={modeParams ?modeParams :mode }jobId={jobId} onHide={onHide} Id={Id} processId={processId} referenceId={referenceId} handleCancelForm={handleCancelForm} reload={reload} handleShowReferenceStepper={handleShowReferenceStepper} />
      
      }

      </>
    }
    </>
  )
};
